import styles from './navigation.module.less';

const NavigationList = ({ children, navigationClassName = '', listClassName = '', ariaLabel }) => {
    return (
        <nav aria-label={ariaLabel} className={navigationClassName}>
            <ul className={[styles.navigationList, listClassName].join(' ')}>{children}</ul>
        </nav>
    );
};

export default NavigationList;
